import React from 'react';
import { useTranslation } from 'react-i18next';

import { openUrl } from '@whelk/utils';
import PlainModal from '@whelk/components/src/Base/PlainModal';
import useLogin from '../../hooks/useLogin';
import { privacyPolicyUrl, termsOfServiceUrl } from '@whelk/const';
import { Button } from '@whelk/components';

const ConfirmModal = () => {
  const { t } = useTranslation();
  const { confirmModalOpen, onSecondConfirm, onSecondCancel } = useLogin();
  return (
    <PlainModal
      open={confirmModalOpen}
      onClickMask={onSecondCancel}
      size='sm'
      title={t('login_user_agreement_privacy_protection')}
      onClose={onSecondCancel}
    >
      <div className='text-col_text02 select-none  pb-8 text-[16px] leading-[22px]'>
        <span>我已阅读并同意&nbsp;</span>
        <span
          className='text-col_accent00 cursor-pointer'
          onClick={() => openUrl(termsOfServiceUrl, true, '_blank')}
        >
          {t('login_user_agreement')}
        </span>
        <span>&nbsp;与&nbsp;</span>
        <span
          className='text-col_accent00 cursor-pointer'
          onClick={() => openUrl(privacyPolicyUrl, true, '_blank')}
        >
          {t('login_privacy_policy')}
        </span>
      </div>

      <div className='flex w-full items-center justify-end gap-4 font-medium'>
        <Button variant='blueText' onClick={onSecondCancel}>
          {t('general_cancel')}
        </Button>
        <Button variant='blue' onClick={onSecondConfirm}>
          {t('login_agree_and_login')}
        </Button>
      </div>
    </PlainModal>
  );
};

export default ConfirmModal;
